export default __webpack_public_path__ + "static/media/position-share-bg.900fbfaa.png";